import { SearchResult } from './SearchResult';
import { getCountryNameFromCode } from '../../lib/utils';

export interface SearchRegionInterface extends SearchResult {
    country_code: string;
    id: number;
    name: string;
}

export class SearchRegion implements SearchRegionInterface {
    public type: string;
    public country_code: string;
    public id: number;
    public name: string;

    constructor(i: SearchRegionInterface) {
        this.type = 'region';
        this.id = i.id;
        this.country_code = i.country_code;
        this.name = i.name;
    }

    public getFullName() {
        return `${this.name}${!!this.country_code ? ', ' + getCountryNameFromCode(this.country_code) : ''}`;
    }
}



// WEBPACK FOOTER //
// ./src/models/Hotels/SearchRegion.ts